// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'MemberTableComponent',
	mixins: [
		tableMixins,
		toastMessageMixins
	],
	props: {
		tableData: {
			type: Array,
			required: true
		},
		isAddMember: {
			type: Boolean,
			default: false
		},
		isTransferAdmin: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tableDataProp: this.tableData
		}
	},
	methods: {
		addMember(customerId) {
			this.$emit('addMember', customerId);
		},
		approveDisapprovedMemberRequest(action, customerId) {
			this.$emit('approveDisapproved', { action ,  customerId });
		},
		transferPrimaryAdmin(customerId) {
			this.$emit('transferPrimaryAdmin', customerId);
		}
	}
}